<template>
  <el-dialog title="Event details" :visible.sync="dialog_visisble">
    <div class="d-block" v-if="modal_data">
      <strong>From:</strong> {{modal_data.start|shortDateTime}}<br>
      <strong>To:</strong> {{modal_data.end|shortDateTime}}<br>
      <strong>Duration (h):</strong> {{modal_data.duration/60}}<br>
      <strong>Duration (min):</strong> {{modal_data.duration}}<br>
      <br>
      <!-- TODO: Alternatively use inline editor here. Would work out of the box -->
      <!-- TODO: More description about what this event is, explain it to users -->

      <el-button
        size="small"
        type="danger"
        @click="onTimeslotDelete(modal_data)" >
        {{modal_data.exception ? 'Delete Exception' : (
          modal_data.deleted ? 'Undo Deletion' :
          'Delete weekly event once' )
        }}
      </el-button>

      <br><br>

      <!-- if only allow reassign for exceptions, otherwise it gets too complicated -->
      <div v-if="modal_data.exception && !modal_data.deleted">
        Reassign to
        <el-select v-model="modal_data.tscId">
          <el-option
            v-for="item in available_timeslot_collections"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :style="{ color: item.color }">
          </el-option>
        </el-select>
      </div>
      <br><br>

      <!-- TODO: There should be a button to allow to set timezone -->
      <p>Usually exceptions are stored without a timezone, which means they are
      always relative to you current timezone, however here you can assign
      a specific timezone if necessary:</p>
      <el-select
        v-model="modal_data.override_timezone"
        filterable
        clearable
        reserve-keyword>
        <el-option
          v-for="item in timezones"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <br><br>
      <!-- <pre>{{modal_data}}</pre> -->

      <div>
        <el-button
          size="small"
          type="info"
          @click="dialog_visisble = true" >
          Cancel
        </el-button>
        <el-button
        style="float: right;"
          v-if="modal_data.exception && !modal_data.deleted"
          size="small"
          type="success"
          @click="onEventModalSave( modal_data.previousTscId, modal_data.tscId, modal_data )" >
          Save
        </el-button>
      </div>

    </div>
  </el-dialog>
</template>

<script>
import moment from '@/moment-gp.js'

export default {
  data() {
    return {
      dialog_visisble: false,
      modal_data: null
    }
  },
  computed: {
    timeslot_collection_list() {
      return this.$models.timeslotCollection.subscribeList().itemsSorted;
    },

    timezones() {
      return moment.tz.names().map(name => ({ label: name, value: name }));
    },

    available_timeslot_collections() {
      // TODO: Doppelt move to getters
      return this.timeslot_collection_list.map((timeslot_collection, idx) => {
        return {
          id: idx,
          label: timeslot_collection.name,
          value: timeslot_collection.$id,
          color: timeslot_collection.color };
      });
    },
  },
  methods: {
    showModal({ modal_data }) {
      this.modal_data = modal_data;
      console.log("this.$refs", this.$refs);
      this.dialog_visisble = true;
    },

    onResetForm() {
      this.modal_data = null;
    },

    onEventModalSave(previousTscId, newTscId, tscData) {
      console.log("onEventModalSave", previousTscId, newTscId, tscData);

      this.dialog_visisble = false;

      /* We have to delete the existing exception and create a new INS-exception */
      this.$api.timeslot_collection_rem_exception({
        timeslotCollectionId: previousTscId,
        exceptionId: tscData.excId
      })

      this.timeslot_collection_add_exception({
        timeslotCollectionId: newTscId,
        exception: {
          type:     'INS',
          from:     tscData.from.toISOString(), // TODO: Don't use ISO strings
          to:       tscData.to.toISOString(), // TODO: Don't use ISO strings
          override_timezone: tscData.override_timezone || null
        }
      })
    },

    onTimeslotDelete(tscData) {
      console.log("onTimeslotDelete", tscData, tscData.exception, tscData.deleted);

      /* TODO: Move this to store */

      if ( tscData.deleted_by ) {
        /* Deleting a 'Delete' event -> Delete DEL-event */
        this.$api.timeslot_collection_rem_exception({
          timeslotCollectionId: tscData.tscId,
          exceptionId: tscData.deleted_by
        })
      } else if ( tscData.exception ) {
        /* Event was created by an INS-Exception -> delete exception */
        this.$api.timeslot_collection_rem_exception({
          timeslotCollectionId: tscData.tscId,
          exceptionId: tscData.excId
        })
      } else {
        /* Event is a rule generated event -> create DEL-exception */
        this.timeslot_collection_add_exception({
          timeslotCollectionId: tscData.tscId,
          exception: {
            type: 'DEL',
            ref:  tscData.rule_origin_id,
            // date: tscData.from.startOf('day').toISOString(true) // TODO!!!
            date: tscData.from.clone().startOf('day').toISOString(true)
          }
        })
      }
      this.dialog_visisble = false;
    },
  }
}
</script>
